/* eslint-disable no-param-reassign */
/* eslint-disable class-methods-use-this */
import Axios from 'axios';
import { Toast } from 'vant';
import Cookies from 'js-cookie';
import { EPOS, getHardWare, getUrlKey, jsonParser } from '@/lib/utils';
import { defaultConfig } from './config';
// import Store from '@/store/index';

// const $store = Store;
const $toast = Toast;

class Http {
    constructor() {
        this.interceptorsRequest();
        this.interceptorsResponse();
    }

    /** 保存当前Axios实例对象 */
    static axiosInstance = Axios.create(defaultConfig);

    /** 统一的错误处理 */
    errorHandler = res => {
        const {
            data: { code, msg },
            status,
            statusText,
        } = res;
        const resultCode = code || status || 500;
        const resultMsg = msg || statusText || 'Internal Server Error';
        $toast(`${resultMsg} (${resultCode})`);
    };

    /** 请求拦截 */
    interceptorsRequest() {
        Http.axiosInstance.interceptors.request.use(
            async config => {
                // 开启进度条动画
                // $store.commit('setLoading', true);

                // todo: 添加公共头部字段
                // config['X-APP-ID'] = ;
                config['X-Language'] = Cookies.get('language');
                return config;
            },
            error => Promise.reject(error)
        );
    }

    /** 响应拦截 */
    interceptorsResponse() {
        const instance = Http.axiosInstance;
        instance.interceptors.response.use(
            response => {
                // 关闭进度条动画
                // $store.commit('setLoading', false);
                const { code = 500, data = {} } = response.data || {};

                // isAll 为 true，返回完整的后端响应
                const res = response.config?.isAll ? response.data : data;

                if (code === 0) return res || {};

                // disabledToast 为 true，跳过统一报错处理逻辑
                if (!response.config?.disabledToast) this.errorHandler(response);
                return Promise.reject(response);
            },
            error => {
                // 关闭进度条动画
                // $store.commit('setLoading', false);

                const $error = error;
                if ($error.response) {
                    this.errorHandler($error.response);
                } else {
                    // 服务器崩溃、断网、超时、CORS 等情况没有 response 响应
                    $toast($error.message);
                }

                return Promise.reject($error.response || $error);
            }
        );
    }

    /** 通用请求工具函数 */
    request(method, url, payload, axiosConfig) {
        const config = {
            method,
            url,
            ...payload,
            ...axiosConfig,
        };

        // 单独处理自定义请求/响应回调
        return new Promise((resolve, reject) => {
            Http.axiosInstance
                .request(config)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    getDefaultHeadParams() {
        const appId =
            getUrlKey('appId') ||
            jsonParser(sessionStorage.getItem('appId') || localStorage.getItem('appId')) ||
            '';
        return {
            'X-APP-ID': appId,
            'X-Language': Cookies.get('language'),
        };
    }

    getDefaultParams() {
        const scene =
            getUrlKey('scene') ||
            jsonParser(sessionStorage.getItem('scene') || localStorage.getItem('scene')) ||
            '';
        const appId =
            getUrlKey('appId') ||
            jsonParser(sessionStorage.getItem('appId') || localStorage.getItem('appId')) ||
            '';

        return {
            epOs: EPOS[getHardWare()],
            epMode: 'web',
            scene,
            appId,
            language: Cookies.get('language'),
        };
    }

    post(url, data, config = {}) {
        const { headers = {}, ...otherConfig } = config;

        const formData = new FormData();
        data = Object.assign(this.getDefaultParams(), data);
        Object.keys(data).forEach(key => {
            formData.append(key, data[key]);
        });

        return this.request(
            'post',
            url,
            { data: formData },
            {
                // prettier-ignore
                headers: Object.assign(
                    headers,
                    this.getDefaultHeadParams(),
                    { 'Content-Type': 'multipart/form-data' },
                ),
                ...otherConfig,
            }
        );
    }

    get(url, params, config) {
        params = Object.assign(this.getDefaultParams(), params);
        return this.request('get', url, { params }, config);
    }
}

export default new Http();
